export const allColors = {
  white: "#ffffff",
  black: "#000000",
  floralWhite: "#fcfbf3",
  lightBlack: "#303030",
  blueCrayola: "#1f75fe",
  jasmine: "#ffda7a",
  jetBlack: "#343434",
  lightSilver: "#d9d9d9",
  philippineGray: "#8c8d8e",
  brightGray: "#eeeeee",
  frenchSkyBlue: "#7baeff",
  darkVanilla: "#d2bcae",
  royalOrange: "#ff914d",
  pastelGray: "#d5c8bf",
  dimGray: "#6b6b68",
  greenMunsell: "#00b67a",
  blueBerry: "#5597ff",
  red: "#ff0000",
  silverSand:"#8C8C8C",
  blueBerry:"#1F4CFE"
};
export const primaryColor = "#11948B";

export const secondaryColor = "#000000";
